import type { TFunction } from 'i18next'

const PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS = {
  validate_requirements:
    'v2.pages.products.detail.rohsFiles.declarationOfConformity.progress.validateRequirements',
  render_pdf:
    'v2.pages.products.detail.rohsFiles.declarationOfConformity.progress.renderPdf',
  persist_output_document:
    'v2.pages.products.detail.rohsFiles.declarationOfConformity.progress.persistOutputDocument',
} as const

type RohsProductComplianceFileDeclarationOfConformityProgressStep =
  keyof typeof PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS

export function rohsProductComplianceFileDeclarationOfConformityProgressMessage(
  step: string,
  translate: TFunction<'common'>
): string | null {
  const key =
    PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS[
      step as RohsProductComplianceFileDeclarationOfConformityProgressStep
    ]
  if (key == null) {
    return null
  }
  return translate(key)
}
